export default __webpack_public_path__ + "static/app-dev-with-swift-logo-c59a8a7727c71ce17422cd2ba188f1e9.png";